module.exports = __webpack_public_path__ + "img/Mask Group1@2x.e77a819a.png";